(ns dre.components.range-picker
  (:require
    ["antd" :refer [DatePicker]]
    ["dayjs" :as dayjs]
    [dre.i18n.utils :refer [tr-later]]))


(def range-presets
  [{:label (tr-later "Last 7 Days")
    :value [(.add (dayjs) -7 "d") (dayjs)]}
   {:label (tr-later "Last 14 Days")
    :value [(.add (dayjs) -14 "d") (dayjs)]}
   {:label (tr-later "Last 30 Days")
    :value [(.add (dayjs) -30 "d") (dayjs)]}
   {:label (tr-later "Last 90 Days")
    :value [(.add (dayjs) -90 "d") (dayjs)]}])


(defn- wrap-range-on-change
  [on-change date]
  (let [[start end] (js->clj date)]
    (on-change {:start start :end end})))


(defn- wrap-presets
  [presets]
  (case presets
    :default range-presets
    nil))


(defn range-picker
  [{:keys [on-change
           presets
           value]
    :or {on-change (constantly nil)}}]
  [:div
   [:> DatePicker.RangePicker
    {:presets (wrap-presets presets)
     :on-change #(wrap-range-on-change on-change %)
     :value value}]])
